import useVariationCard from "./hooks/useVariationCard";
import VariationImage from "./VariationImage";
import useLang from "../../hooks/useLang";
import { TertiaryParagraph } from "../../components/Paragraph";
import Icon from "../../components/Icon";
import classNames from "classnames";
import styles from "./variations.module.css";

const VariationCard = ({
  variation,
  hotspots,
  getPrice,
  defaultVariationId,
}) => {
  const { handleClick, hover, setHover } = useVariationCard();
  const lang = useLang();
  return (
    <div
      className={classNames(styles.variationCard, {
        [styles.hovering]: hover,
        [styles.active]: variation?.active,
      })}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={() => {
        handleClick(variation.id);
      }}
    >
      <VariationImage img={variation.img} hotspots={hotspots} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap-xs)",
        }}
      >
        <div
          style={{
            display: "flex",
            height: "20px",
            gap: "4px",
            alignItems: "center",
          }}
        >
          <TertiaryParagraph
            style={{
              color: "var(--clr-neutral-900)",
              fontWeight: "var(--text-weight-bold)",
            }}
          >
            {variation.id}
          </TertiaryParagraph>
          {variation?.id === defaultVariationId ? (
            <Icon check color={"blue"} />
          ) : null}
        </div>
        {variation?.parameters?.map((parameter) => (
          <TertiaryParagraph key={Object.keys(parameter)[0]}>{`${lang(
            Object.keys(parameter)[0]
          )}: ${
            Object.keys(parameter)[0] === "width"
              ? Object.values(parameter)[0] * 10 + " mm"
              : Object.values(parameter)[0]
          }`}</TertiaryParagraph>
        ))}
        <TertiaryParagraph>
          {`${lang("price")}: `}
          <span
            style={{
              fontWeight: variation?.manualPrice ? "600" : "initial",
              color: variation?.manualPrice ? "#333" : "var(--clr-neutral-500)",
            }}
          >{`${
            variation?.manualPrice
              ? variation?.price
              : getPrice({
                  parameters: variation?.parameters,
                }).result
          } €`}</span>
        </TertiaryParagraph>
      </div>
    </div>
  );
};

export default VariationCard;
